import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import UserLoginContext from "../context/userLoginContext";
import AdminAttendanceSummary from "../page-components/attendance/admin/admin-attendance";
import server from "../server";
import SupervisorAttendance from "../page-components/attendance/supervisor/supervisor-attendance";
import EmployeeAttendance from "../page-components/attendance/employee-attendance/employee-attendance";
import attendance from "../resources/attendance";
import PageHeader from "../page-components/common/page-header/page-header";
import { Button, Segmented } from "antd/lib";
import { Calendar, ChartPie, List, User } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import "../styles/component/attendance.scss";


const tabs = [
    {
        label: 'Team',
        value: 'team',
        icon: <ChartPie/>
    },
    {
        label: 'Personal',
        value: 'self',
        icon: <User/>
    }
];

const empAttendanceTab = [
    {
        value: 'list',
        label: 'List',
        icon: <List/>
    },
    {
        value: 'calendar',
        label: 'Calendar',
        icon: <Calendar/>
    }
]

const Attendance: React.FC = () => {

    const {user} = useContext(UserLoginContext);
    //to get empId from url state.
    const location = useLocation();
    const {empId} = (location.state) || {};
    const [isSupervisor, setIsSupervisor] = useState<boolean>(false);
    const [view, setView] = useState<'team' | 'self'>('self');
    const [empAttendanceView, setEmpAttendanceView] = useState<'calendar' | 'list'>('list');
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            //check if user has employeeID
            if (user.employeeId) {
                //check if employee is a supervisor.
                const res = await server.employee.checkReportingManagerStatus(user.employeeId);
                setIsSupervisor(res);
            }
        })();
    }, [user, empId])

    const resource = attendance;

    const pageContent = user.isAdmin ?
        resource.attendanceHeader.admin :
        (isSupervisor && view == 'team') ? resource.attendanceHeader.supervisor :
            resource.attendanceHeader.employeeSelf;

    function navigateToStats() {
        navigate('/my/attendance/stats', {state: {employeeId: user.employeeId}});
    }

    return (
        <>
            <PageHeader
                title={pageContent.mainHeading}
                description={pageContent.description}
                actions={<>
                    {user.employeeId && view === 'self' &&
                    <>
                        <Button type={'primary'} onClick={() => navigateToStats()}>
                            View Stats
                        </Button>
                        <Segmented
                            className={'attendance-header__attendance-view-toggle'}
                            options={empAttendanceTab}
                            value={empAttendanceView}
                            onChange={(val: string) => setEmpAttendanceView(val as ('calendar' | 'list'))}
                        />
                    </>}
                    {isSupervisor &&
                    <Segmented
                        className="attendance-header__scope-toggle"
                        options={tabs}
                        value={view}
                        onChange={(val: string) => setView(val as ('team' | 'self'))}
                    />}
                </>}
            />
            {user.isAdmin ?
                <AdminAttendanceSummary/>
                :
                (isSupervisor && view == 'team') ?
                    <SupervisorAttendance supervisorId={user.employeeId!}/>
                    :
                    (user.employeeId && (
                        <EmployeeAttendance
                            employeeId={user.employeeId}
                            view={empAttendanceView}
                        />
                    ))

            }
        </>
    );
};

export default Attendance;
